import {useTranslation} from "react-i18next";
import {cleanUpHistoryRooms} from "../../../../../redux/actions/rooms/actions.js";
import {selectActiveRoomTab} from "../../../../../redux/actions/lobby/actions.js";
import {useDispatch} from "react-redux";

const HistoryRoomTab = function (props) {

    const {
        roomId,
        isActive,
    } = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(selectActiveRoomTab({roomId}));
    }

    const onClose = (event) => {
        event.stopPropagation();
        dispatch(cleanUpHistoryRooms());

        dispatch(selectActiveRoomTab({roomId: null}));
    }

    return (
        <div className={`header-active-game-item-wrapper ${isActive ? "active" : ""}`} onClick={handleClick}>
            <div className="header-active-game-item">
                <i className="icon-history"/>
                <p>{t('tabs.game')} {roomId} </p>
                <i className="icon-close" onClick={(e) => onClose(e)}/>
            </div>
        </div>
    )
}

export default HistoryRoomTab